export default "__VITE_ASSET__BfRnIwWN__"